import { colors } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';

interface Stylings {
  $noBorder: boolean;
}

export const StepHeaderStyled = styled.header<Stylings>`
  padding-bottom: 3rem;
  ${(props): CSSProp =>
    props.$noBorder
      ? css`
          border: none;
        `
      : css`
          border-bottom: 1px solid ${colors.neutral[300]};
        `}
`;

export const StepTitleStyled = styled.h3`
  color: ${colors.neutral[900]};
  font-size: 2rem;
  line-height: 2.8rem;
  margin-top: 0;
  margin-bottom: 1rem;
`;

export const StepInfoStyled = styled.p`
  color: ${colors.neutral[700]};
  font-size: 1.6rem;
  line-height: 2.4rem;
  margin: 0;
`;
